import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class NotificacoesModel {

    // operacoesNoDia: Boolean = false
    // curtoPrazo: Boolean = false
    // longoPrazo: Boolean = false

    notificacoes_curto_prazo_brasil: boolean = true;
    notificacoes_medio_prazo_brasil: boolean = true;
    notificacoes_longo_prazo_brasil: boolean = true;
    notificacoes_curto_prazo_eua: boolean = true;
    notificacoes_medio_prazo_eua: boolean = true;
    notificacoes_longo_prazo_eua: boolean = true;
    notificacoes_curto_prazo_cripto: boolean = true;
    notificacoes_medio_prazo_cripto: boolean = true;
    notificacoes_longo_prazo_cripto: boolean = true;
    notificacoes_carteira_recomendada: boolean = true;
    notificacoes_opcoes: boolean = true;

    enviaOpcoesNotificacoes(notificacoesModel: NotificacoesModel): Promise<PhicubeResponse> {
        // return new GatewayService().requestPut('/api/configuracoes/notificacoes', notificacoesModel)
        return new GatewayService().requestPut('/api/user/preferencias/notificacoes', notificacoesModel)
    }

    obtemOpcoesNotificacoes(): Promise<PhicubeResponse> {
        // return new GatewayService().requestGet('/api/configuracoes/notificacoes')
        return new GatewayService().requestGet('/api/user/preferencias/notificacoes')
    }

    deletaOpcoesNotificacoes(): Promise<PhicubeResponse> {
        // return new GatewayService().requestPut('/api/configuracoes/notificacoes', notificacoesModel)
        return new GatewayService().requestDel('/api/user/preferencias/notificacoes')
    }
}